import { getConfirmPromptRef } from '~/components/Global/Interactions/Confirm/confirmPrompt'

export const confirm = async (
  title?: string,
  content?: string,
  textConfirm?: string
): Promise<boolean> =>
  await getConfirmPromptRef().current(title, content, textConfirm)
